import { render, staticRenderFns } from "./PageConfig.vue?vue&type=template&id=183b0b39&"
import script from "./PageConfig.vue?vue&type=script&lang=js&"
export * from "./PageConfig.vue?vue&type=script&lang=js&"
import style0 from "./PageConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports